// extracted by mini-css-extract-plugin
export default {"status":"ActiveProblemAndConditionSection_status__sqFIC","stage":"ActiveProblemAndConditionSection_stage__JSFIv"};